<div class="card_comp" [ngClass]="{'card_comp1': type == 'dark', 'card_comp': type == 'light'}">
    
<h2>{{heading}}</h2>

<div class="row">
    <div class="col-md-4" *ngFor="let cardread of cardList;let i = index">
        <div class="about-gmat-card">
            <img [src]="cardread.image" alt="">
            <h4>{{cardread.title}}</h4>

            <a class="{{ 'card' + i }}" target="_blank" href="{{cardread.link}}">Read More <i class="bi bi-arrow-right"></i></a>
        </div>
    </div>

   

</div>
    
</div>
